module.exports = __webpack_public_path__ + "img/Stella Yuan.2862b570.jpg";